import React, { Component } from 'react'
import Header from '../Header'
import './XVw.css'

class XVw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXVw">
                    <p className="textXVw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XVw